import { CoreToastMessage, TOAST_ERROR_OPTIONS, TOAST_SUCCESS_OPTIONS } from '@components'
import toast, { type ToastOptions } from 'react-hot-toast'

const mergeToastOptions = (base: ToastOptions, override?: ToastOptions): ToastOptions => {
  if (!override) return base
  const merged: ToastOptions = {
    ...base,
    ...override,
    style: { ...base.style, ...override.style },
    ariaProps: { ...base.ariaProps, ...override.ariaProps },
    iconTheme: { ...base.iconTheme, ...override.iconTheme }
  }
  const className = [base.className, override.className].filter(Boolean).join(' ')
  if (className) merged.className = className
  return merged
}

export const toastFailure = (title: string, subtitle?: string, options?: ToastOptions) => {
  if (title) {
    toast.remove()
    toast.error(CoreToastMessage({ title, subtitle }), mergeToastOptions(TOAST_ERROR_OPTIONS, options))
  }
}

export const toastSuccess = (title: string, subtitle?: string, options?: ToastOptions) => {
  if (title) {
    toast.remove()
    toast.success(CoreToastMessage({ title, subtitle }), mergeToastOptions(TOAST_SUCCESS_OPTIONS, options))
  }
}
